module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/end_quote-6f98e89a4f6bd2e6e8fd117b07ade871.svg";